export default {
  activeLoader: state => {
    return state.loading;
  },
  loaderProgress: state => {
    return state.progress;
  },
};
